import { pipe } from 'fp-ts/lib/function';
import { type Decoder, type InputOf, map, type TypeOf, union } from 'io-ts/Decoder';

import { undefinedDecoder } from './undefined';

export function withDefault<T extends Decoder<unknown, unknown>>(
	decoder: T,
	defaultValue: TypeOf<T>
): Decoder<InputOf<T>, TypeOf<T>> {
	return union(
		decoder,
		pipe(
			undefinedDecoder,
			map(() => defaultValue)
		)
	);
}
